import React from 'react'

const CompletedCircle = () => {
    return (
        <div className='little-circle-green' >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="4.5"
                stroke="currentColor"
                className="completed-button-img-white">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
            </svg>

        </div>
    )
}

export default CompletedCircle